import React from "react";
import theme from "../../Styles/theme";
import { ModalDivX } from "../ModalDivX";
import Modal from "react-modal";
import { Button, Container } from "./styles";
import { User, Home } from "react-feather";
import { FaWarehouse } from "react-icons/fa";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
}

export function ImovelModalOptions({ open, onClose }: Props) {
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <Container>
        <Button>
          Editar Imóvel{" "}
          <Home color={theme.colors.light} size={"max(12px, 1.4vw)"} style={{ marginLeft: "1vw"}}/>
        </Button>
        <Button>
          Adicionar Benfeitorias
          <FaWarehouse color={theme.colors.light} size={"max(12px, 1.4vw)"} style={{ marginLeft: "1vw"}} />
        </Button>
        <Button>
          Editar Transmitente e Adquirinte
          <User color={theme.colors.light} size={"max(12px, 1.4vw)"} style={{ marginLeft: "1vw"}} />
        </Button>
      </Container>
    </Modal>
  );
}
